import { motion } from 'framer-motion'
import { Target, CheckCircle2, XCircle } from 'lucide-react'
import { bannerSlideVariants, useMotionVariants } from '../motion/motionTokens'

// Lower-third banner for the board's verdict on the season objective.
export function ObjectiveBanner({ met, label, divisionName }: {
  met: boolean
  label: string
  divisionName?: string
}) {
  const banner = useMotionVariants(bannerSlideVariants)
  const Icon = met ? CheckCircle2 : XCircle

  return (
    <motion.div
      className="achievement-banner"
      variants={banner}
      initial="initial"
      animate="enter"
      exit="exit"
      style={
        met
          ? undefined
          : { background: 'var(--bg-surface)', color: 'var(--text-primary)', boxShadow: 'var(--shadow-lg)' }
      }
    >
      <span style={{ position: 'relative', flex: 'none', display: 'flex' }}>
        <Icon size={30} color={met ? undefined : 'var(--danger)'} />
      </span>
      <div style={{ position: 'relative', minWidth: 0 }}>
        <div className="achievement-banner-kicker">
          <Target size={11} style={{ verticalAlign: '-1px', marginRight: 4 }} />
          {met ? 'Objetivo cumplido' : 'Objetivo fallado'}
        </div>
        <div className="achievement-banner-name">{label}</div>
        {divisionName && met && <div className="achievement-banner-reward">{divisionName}</div>}
      </div>
    </motion.div>
  )
}
